import React from 'react';
import { Box, Text, Flex, BoxProps } from '../../primitives';
import rem from '../../../utils/rem';

type Props = {
  title?: string;
  rightTitle?: string;
  value?: number;
  titleColor?: string;
  secondaryValue?: number;
  titleSize?: number;
  text?: string;
  secondaryText?: string;
  containerStyle?: Omit<BoxProps, 'color'>;
  color?: 'apricot' | 'accent';
};

const BAR_THICKNESS = 6;
const PROGRESS_THICKNESS = 16;

const ValueBar = ({
  title,
  rightTitle,
  value = 0,
  titleColor,
  secondaryValue,
  secondaryText,
  titleSize,
  containerStyle,
  text,
  color = 'apricot',
}: Props) => {
  const displayBar = (
    fillValue: number,
    insideText?: string,
    isSecondBar = false
  ) => (
    <Box
      py={rem((PROGRESS_THICKNESS - BAR_THICKNESS) / 2)}
      {...(isSecondBar && { mt: 'medium' })}
    >
      <Box
        position="relative"
        height={rem(BAR_THICKNESS)}
        backgroundColor="gallery"
        borderRadius={rem(BAR_THICKNESS / 2)}
      >
        <Box
          position="absolute"
          top="50%"
          left="0"
          width={`${fillValue * 100}%`}
          height={rem(PROGRESS_THICKNESS)}
          backgroundColor={isSecondBar ? 'apricot' : color}
          borderRadius={rem(PROGRESS_THICKNESS / 2)}
          transform="translateY(-50%)"
        >
          {insideText && (
            <Text
              textTransform="uppercase"
              color="light"
              variant="small"
              lineHeight="inherit"
              fontSize={rem(10)}
              pl={rem(7)}
              pb={rem(2)}
            >
              {insideText}
            </Text>
          )}
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box width="100%" {...containerStyle}>
      <Flex justifyContent="space-between">
        {!!title && (
          <Text
            color={titleColor ? titleColor : 'primary'}
            fontSize={titleSize ? rem(titleSize) : 'size18'}
            mb="xSmall"
          >
            {title}
          </Text>
        )}
        {!!rightTitle && (
          <Text
            color={titleColor ? titleColor : 'primary'}
            fontSize={titleSize ? rem(titleSize) : 'size18'}
            mb="xSmall"
          >
            {rightTitle}
          </Text>
        )}
      </Flex>
      {displayBar(value, text)}
      {secondaryValue && displayBar(secondaryValue, secondaryText, true)}
    </Box>
  );
};

export default ValueBar;
